import {
  CHECK_LOGIN,
  CHECK_LOGIN_FAILED,
  CHECK_LOGIN_SUCCESS,
  CLEAR_TRIAL_EXPIRED,
  IAuthActions,
  LOGIN,
  LOGIN_ERROR,
  LOGIN_SUCCESS,
  LOGOUT,
  SET_USER,
  TOKEN_REFRESHED,
  TRIAL_EXPIRED,
} from "Actions";
import { IAuthState } from "Interfaces";
import { Reducer } from "redux";

export const authReducer: Reducer<IAuthState, IAuthActions> = (
  state = { tokens: null, status: "INIT", user: null, trialExpired: false },
  action
): IAuthState => {
  switch (action.type) {
    case LOGIN:
    case CHECK_LOGIN: {
      return {
        ...state,
        status: CHECK_LOGIN,
        tokens: null,
      };
    }
    case CHECK_LOGIN_SUCCESS:
    case TOKEN_REFRESHED:
    case LOGIN_SUCCESS: {
      return { ...state, status: action.type, tokens: action.payload };
    }
    case LOGOUT:
    case CHECK_LOGIN_FAILED:
    case LOGIN_ERROR: {
      return { ...state, status: action.type, tokens: null };
    }
    case SET_USER: {
      return { ...state, status: action.type, user: action.payload };
    }
    case TRIAL_EXPIRED: {
      return { ...state, trialExpired: true };
    }
    case CLEAR_TRIAL_EXPIRED: {
      return { ...state, trialExpired: false };
    }
  }
  return state;
};
